import React, { useRef, useState, useEffect } from "react";
import axios from 'axios';

import {API_URL} from "../../../utils/Common";

const formInit = Object.freeze({
  semana_siembra: "",
});

const InvViveros = (props) => {

  const [inventario, setInventario] = useState([]);
  const [form, updateForm] = useState(formInit);

  useEffect(() => {
    
  }, []);

  const getInventario = () => {
    console.log(form);
    axios.get(API_URL + '/getInvVivero?ss='+form.semana_siembra)
      .then(r => {
        console.log(r.data);
        setInventario(r.data.inventario);
      });
  }

  const onChange = (e) => {
    updateForm({
      ...form,
      [e.target.name]: e.target.value.trim(),
    });
  }

  return (
    <div className="w-full p-3 right-0">
        <div className="bg-white border rounded shadow-xl">
            <div className="border-b rounded-t p-3 bg-orange-900">
                <h5 className="font-bold uppercase text-white">IVENTARIO DE VIVERO</h5>
                <p className="text-white text-sm">Información del inventario del vivero</p>
            </div>
            <div className="p-5 rounded-b">
                {/* ---- CONTENIDO --- */}
              <form>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full md:w-1/6 px-3 mb-6 md:mb-0">
                    <input
                      className="text-sm text-right appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-2 px-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      name="semana_siembra"
                      onChange={onChange}
                      placeholder="semana siembra (yyww)"
                      type="text" />
                  </div>

                    <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                        <button
                           onClick={getInventario}
                           type="button"
                           className="text-sm bg-orange-800 hover:bg-orange-700 text-white py-2 px-4 rounded shadow"
                        >
                           Ver Inventario
                        </button>
                    </div>
               </div>
              </form>
                {inventario.length > 0 &&
                <table className="ui celled selectable small table">
                  <thead>
                    <tr>
                      <th className="center aligned" 
                          style={{'backgroundColor':'#6F2D1E', color: 'white'}}>
                        Tipo de Flor
                      </th>  
                      <th className="center aligned" 
                          style={{'backgroundColor':'#6F2D1E', color: 'white'}}>
                        Semana Siembra
                      </th>
                      <th className="center aligned" 
                          style={{'backgroundColor':'#6F2D1E', color: 'white'}}>Día Siembra</th>
                      <th className="center aligned" 
                          style={{'backgroundColor':'#6F2D1E', color: 'white'}}>Semana Aclimatación</th>
                      <th className="center aligned" 
                          style={{'backgroundColor':'#6F2D1E', color: 'white'}}>No. Charolas</th>
                      <th className="center aligned" 
                          style={{'backgroundColor':'#6F2D1E', color: 'white'}}>% Germinación</th>
                      <th className="center aligned" 
                          style={{'backgroundColor':'#6F2D1E', color: 'white'}}>Plantas</th>
                    </tr>
                  </thead>
                  <tbody>
                    {inventario.map((inv, i) => {
                      return (
                        <tr key={i}>
                          <td>{inv.nombre_comun + " " + inv.nombre + " " + inv.color}</td>
                          <td className="center aligned">{inv.semana_siembra}</td>
                          <td className="center aligned">{inv.dia} ({inv.dia_siembra})</td>
                          <td className="center aligned">{inv.semana_aclimatacion}</td>
                          <td className="center aligned">{inv.no_charolas}</td>
                          <td className="center aligned">{inv.germinacion}</td>
                          <td className="center aligned">{inv.plantas.toLocaleString()}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>}
            </div>
        </div>
    </div>
  );
}

export default InvViveros;
